import React from 'react'
import './ContactForm.css'
import user_icon from '../../assets/person.png'
import contact_image from '../../assets/contact-us.png'
import email_icon from '../../assets/email.png'
import message_icon from '../../assets/Message.png'

const ContactForm = () => {
    return (
        <div className='container'>
            <div className='image_container'>
                <img src={contact_image} alt='' />
            </div>
            <div className='form_container'>
                <div className='header'>
                    <div className='text'>Free free to reach out to us</div>
                    <div className='underline'></div>
                </div>
                <div className='inputs'>
                    <div className='input'>
                        <img src={user_icon} alt='' />
                        <input type='text' placeholder='Name' />
                    </div>
                    <div className='input'>
                        <img src={email_icon} alt='' />
                        <input type='email' placeholder='Email Id' />
                    </div>
                    <div className='input message'>
                        <textarea name="text" wrap="soft" placeholder='Message'> </textarea>
                    </div>
                </div>
                <div className='submit'>Send</div>
            </div>
        </div>
    )
}

export default ContactForm